<template>
  <span>
    <template v-if="showPdas">
      <component
        :is="componentName"
      />
    </template>
    <template v-else>
      <detail />
    </template>
  </span>
</template>
<script>
import DetailPDASIframe from './DetailsPDAS-iframe.vue';
import DetailV3Iframe from './Version3/DetailsV3-iframe.vue';
import DetailV6Iframe from './Version6/Details-iframeV6.vue';
import DetailV7Iframe from './Version7/DetailsV7-iframe.vue';

export default {
  name: 'DashbhoardIframeHome',
  components: {
    DetailPDASIframe,
    DetailV3Iframe,
    DetailV6Iframe,
    DetailV7Iframe,
  },
  data() {
    let componentName = '';
    if (window.localStorage.getItem('userType') === 'iframe-link-user') {
      componentName = this.$cgiSettings.iframeSettings.detailsView;
    } else if (window.localStorage.getItem('userType') === 'dashboard-link-user') {
      componentName = this.$cgiSettings.dashboardSettings.detailsView;
    } else {
      componentName = 'DetailPDASIframe';
    }
    return {
      showPdas: this.$cgiSettings.showPdas,
      componentName,
    };
  },
};
</script>
